









































































import { Component, PropSync, Vue } from "vue-property-decorator";

@Component
export default class AgendaSupportGuide extends Vue {
  @PropSync("value", { type: Boolean, default: false }) public isOpen!: boolean;

  public accionesRapidas: any[] = [
    /* {
      accion: "confirmar",
      label: "Confirmar",
      icon: "mdi-check-circle-outline",
      color: "success",
      descripcion: "La cita queda validada para continuar su gestión interna.",
    },
    {
      accion: "marcar_enviada_gesden",
      label: "Enviar a Gesden",
      icon: "mdi-export-variant",
      color: "warning",
      descripcion: "Pasa la cita al paso de integración con Gesden.",
    },*/
    {
      accion: "marcar_insertada_gesden",
      label: "Insertada en Gesden",
      icon: "mdi-database-check-outline",
      color: "success",
      descripcion:
        "Confirma que la cita ya quedó registrada manualmente en Gesden.",
    },
    {
      accion: "confirmar_cancelacion_gesden",
      label: "✓ Cancelé en GESDEN",
      icon: "mdi-calendar-remove",
      color: "deep-orange",
      descripcion:
        "El paciente canceló una cita ya insertada en Gesden. Confirma que la has cancelado allí manualmente.",
    },
    {
      accion: "confirmar_reagendado_gesden",
      label: "✓ Moví en GESDEN",
      icon: "mdi-calendar-arrow-right",
      color: "amber darken-2",
      descripcion:
        "El paciente eligió otra fecha en una cita ya insertada en Gesden. Confirma que la has movido allí manualmente.",
    },
    {
      accion: "marcar_conflicto",
      label: "Marcar conflicto",
      icon: "mdi-alert-circle-outline",
      color: "error",
      descripcion:
        "Señala incidencias para revisión manual. Úsalo si no puedes actuar en Gesden.",
    },
    {
      accion: "cancelar",
      label: "Cancelar",
      icon: "mdi-cancel",
      color: "error",
      descripcion: "Detiene la cita definitivamente.",
    },
    /*{
      accion: "rechazar",
      label: "Rechazar",
      icon: "mdi-close-circle-outline",
      color: "error",
      descripcion: "Se descarta la solicitud por no ser viable.",
    },*/
  ];

  public flujo: string[] = [
    "Añade o localiza paciente y configura servicio/canal/horario.",
    "Guarda y revisa el estado actual en el panel derecho.",
    "Usa acciones rápidas para mover la cita por el workflow.",
    "Si la cita ya estaba en Gesden y el paciente cancela o cambia de fecha, aparecerá en la bandeja lateral con borde rojo/amarillo.",
    "Abre la cita, actúa en Gesden y confirma con el botón correspondiente.",
    "Consulta historial para auditar qué cambió y cuándo.",
  ];

  public close() {
    this.isOpen = false;
  }

  public pedirAyudaIA() {
    this.$emit("request-ai-help");
  }
}
